import { IStat } from "shared-types";
import { IFacet } from "shared-services";
import { IOption } from "../../../generics/interfaces";
import { IDropdownCheckboxValueItemConfig } from "../../Molecules/DropdownCheckbox/DropdownCheckboxValue";

export function optionToFacet(option: { value: unknown; name: string }) {
  return { name: option.name, id: option.value };
}

export function facetToOption(facet: IFacet): IOption<number> {
  return {
    name: facet.name,
    value: facet.id,
  };
}

export function facetToCheckboxOption(
  facet: IFacet
): IDropdownCheckboxValueItemConfig {
  return {
    label: facet.name,
    value: String(facet.id),
    selectedLabel: "",
  };
}

export function facetToCheckboxOptionWithStats(
  facet: IFacet,
  stats: IStat<number>[] = []
): IDropdownCheckboxValueItemConfig {
  const stat = stats.find((stat) => +stat.value === +facet.id);
  const count = stat?.count || 0;

  return {
    label: facet.name,
    value: String(facet.id),
    labelPostFix: count,
    disabled: count === 0,
    selectedLabel: "",
  };
}
